import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

interface Meta {
  page: number;
  take: number;
  itemCount: number;
  pageCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  // standalone: true,
  // imports: [SharedModule],
})
export class PaginationComponent implements OnInit {
  @Input() meta!: Meta;

  @Output() goPrev = new EventEmitter<boolean>();
  @Output() goNext = new EventEmitter<boolean>();
  @Output() goPage = new EventEmitter<number>();
  teamProfile: any;
  teamColor!: any;
  constructor(
    public translate: TranslateService,
    // public teamService: TeamService
  ) {}

  ngOnInit(): void {
    // this.teamService.getTeam().subscribe((res) => {
    //   this.teamProfile = res;
    //   if (res) {
    //     this.teamColor = res.setting.mainBtn.backgroundColor;
    //   }
    // });
  }

  onPage(n: number): void {
    this.goPage.emit(n);
  }

  onPrev(): void {
    this.goPrev.emit(true);
  }

  onNext(next: boolean): void {
    this.goNext.emit(next);
  }

  getPages(): number[] {
    const c = Math.ceil(this.meta.itemCount / this.meta.take);
    const p = this.meta.page || 1;
    const pagesToShow = this.meta.take || 9;
    const pages: number[] = [];
    pages.push(p);
    const times = pagesToShow - 1;
    for (let i = 0; i < times; i++) {
      if (pages.length < pagesToShow) {
        if (Math.min.apply(null, pages) > 1) {
          pages.push(Math.min.apply(null, pages) - 1);
        }
      }
      if (pages.length < pagesToShow) {
        if (Math.max.apply(null, pages) < c) {
          pages.push(Math.max.apply(null, pages) + 1);
        }
      }
    }
    pages.sort((a, b) => a - b);
    return pages;
  }
}
